import { Link } from "react-router-dom";
import { Plus } from "lucide-react";
import { useEnabled } from "@/lib/layout";

export const Claves = ({ points, title = "Claves de la noticia" }) =>
  points?.length > 0 && (
    <section className="claves border-l-4 border-primary bg-amber-50/70 dark:bg-amber-950/20 p-6 sm:p-8 mb-10" aria-labelledby="claves-title" data-testid="article-key-points">
      <h2 id="claves-title" className="kicker text-primary mb-4">{title}</h2>
      <ul className="space-y-3">
        {points.map((k, i) => (
          <li key={i} className="flex gap-3 font-serif text-[1.08rem] leading-relaxed">
            <span className="mt-[0.7rem] h-1.5 w-1.5 bg-primary shrink-0" />
            {k}
          </li>
        ))}
      </ul>
    </section>
  );

export const Faqs = ({ faqs, title = "Preguntas frecuentes" }) =>
  faqs?.length > 0 && (
    <section className="mt-14" aria-labelledby="faq-title" data-testid="article-faqs">
      <h2 id="faq-title" className="font-display font-black text-2xl sm:text-3xl tracking-tight mb-4">{title}</h2>
      {faqs.map((f, i) => (
        <details key={i} className="group border-t border-border py-4 last:border-b" data-testid={`faq-item-${i}`}>
          <summary className="cursor-pointer list-none flex items-start justify-between gap-4 font-semibold text-lg leading-snug [&::-webkit-details-marker]:hidden">
            {f.q}
            <Plus className="h-5 w-5 mt-0.5 shrink-0 text-primary transition-transform duration-300 group-open:rotate-45" />
          </summary>
          <p className="mt-3 text-muted-foreground leading-relaxed">{f.a}</p>
        </details>
      ))}
    </section>
  );

const TAG = "border border-border px-3 py-1.5 text-sm";

export const Tags = ({ tags }) => {
  const linked = useEnabled("tag");
  if (!tags?.length) return null;
  return (
    <div className="mt-8 flex flex-wrap gap-2" data-testid="article-tags">
      {tags.map((t) => linked ? (
        <Link key={t} to={`/tema/${encodeURIComponent(t)}`} className={`${TAG} hover:border-primary hover:text-primary transition-colors`} data-testid={`tag-link-${t.replace(/\s+/g, "-")}`}>#{t}</Link>
      ) : (
        <span key={t} className={`${TAG} text-muted-foreground`} data-testid={`tag-label-${t.replace(/\s+/g, "-")}`}>#{t}</span>
      ))}
    </div>
  );
};
